import React from 'react';
import { Button } from 'carbon-components-react';
import { Popup24 } from '@carbon/icons-react';
import Cta from '../../Molecules/Cta/Cta';
import PublicImage from 'src/common/components/PublicImage';
const greetingImage = 'images/spss_gif.gif';
import './Welcome.scss';
import {
  convertToString,
  TranslationFunction,
} from 'src/common/hooks/widgets/useTranslation';

type WelcomeProps = {
  handleLaunchModal: () => void;
  model2: boolean;
  setModel2: React.Dispatch<React.SetStateAction<boolean>>;
  modalBtnLangText: string;
  toggleCountry: boolean;
  localExist: boolean;
  flag: boolean;
  useTranslation: TranslationFunction;
};

const Welcome = ({
  handleLaunchModal,
  setModel2,
  modalBtnLangText,
  toggleCountry,
  localExist,
  flag,
  useTranslation,
}: WelcomeProps) => {
  return (
    <div className="bx--row welcome">
      <div className="bx--col-lg-10 bx--col-md-3 bx--col-sm-2 ml-02">
        <div className="bx--row mt-mb-02">
          <div className="main-title">{useTranslation('landing_title')}</div>
        </div>
        <div className="bx--row mt-mb-02">
          <Button onClick={handleLaunchModal} renderIcon={Popup24}>
            {useTranslation('launch_btn_text')}
          </Button>
          {flag && localExist && toggleCountry && (
            <Cta
              value={`${convertToString(
                useTranslation('accessPageCapitalized', true),
              )} ${modalBtnLangText}`}
              handleClick={() => setModel2(true)}
              kind="tertiary"
              iconType="arrow"
              classes="ml2"
            />
          )}
        </div>
      </div>
      <div className="bx--col-lg-5 bx--col-md-3 bx--col-sm-1 animation">
        <PublicImage
          imgPath={'images/spss_gif.gif'}
          widgetId="spss-purchase-advisor-self-assessment"
          alt="animation-image"
          id="img1"
        />
      </div>
    </div>
  );
};

export default Welcome;
